import { useTranslation } from "react-i18next";
import { Globe2, Plug } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

const Dot = ({ on }) => (
  <span className={`h-2.5 w-2.5 rounded-full ${on ? "bg-primary" : "bg-destructive"}`} />
);

export const GeoUsageCard = ({ geo, integrations, onOpen }) => {
  const { t } = useTranslation();
  if (!geo) return null;
  const top = geo.countries[0]?.requests || 1;

  return (
    <NeuCard
      data-testid="system-geo-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <Globe2 className="h-4 w-4 text-primary" /> {t("system.geo", { days: geo.days })}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        {t("system.geoHint", { ips: geo.unique_ips, resolved: geo.resolved_ips })}
      </p>

      {!geo.countries.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="system-geo-empty">
          {t("system.geoEmpty")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-2" data-testid="system-countries">
          {geo.countries.map((c) => (
            <li key={c.country} className="rounded-2xl bg-background px-3 py-2.5 shadow-neu-sm">
              <div className="flex items-center justify-between gap-3 text-xs font-bold">
                <span className="truncate">{c.country}</span>
                <span className="font-mono text-muted-foreground" dir="ltr">
                  {c.requests} · {t("system.devices", { count: c.devices })}
                </span>
              </div>
              <div className="mt-1.5 h-1.5 rounded-full bg-primary/10">
                <div className="h-1.5 rounded-full bg-primary" style={{ width: `${(c.requests / top) * 100}%` }} />
              </div>
            </li>
          ))}
        </ul>
      )}

      {integrations ? (
        <div className="mt-5 border-t border-border/50 pt-4" data-testid="system-integrations">
          <p className="label-xs flex items-center gap-2">
            <Plug className="h-4 w-4 text-primary" /> {t("system.integrations")}
          </p>
          <ul className="mt-3 grid gap-2 text-xs font-bold sm:grid-cols-2">
            {[
              [t("system.face"), integrations.face_provider !== "mock", integrations.face_provider],
              [t("system.stripe"), integrations.stripe, integrations.stripe ? "live key" : "—"],
              [t("system.emails"), integrations.email, integrations.email ? "resend" : "—"],
              [t("system.tokens"), integrations.tokens_in_wallets > 0, `${integrations.tokens_in_wallets}`],
            ].map(([label, on, hint]) => (
              <li key={label} className="flex items-center justify-between gap-2 rounded-2xl bg-background px-3 py-2 shadow-neu-sm">
                <span className="flex items-center gap-2">
                  <Dot on={on} /> {label}
                </span>
                <span className="font-mono text-[11px] text-muted-foreground">{hint}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </NeuCard>
  );
};
